// Maps area names (as shown in AreaPills) to their published landing pages.
// All northern-suburb areas are consolidated into one hub page (1 topic = 1 URL).
const NORTHERN_HUB = '/kommotirio-voreia-proastia';

export const AREA_LINKS = {
  'Χαλάνδρι': '/kommotirio-chalandri',
  'Φιλοθέη': NORTHERN_HUB,
  'Ψυχικό': NORTHERN_HUB,
  'Νέο Ψυχικό': NORTHERN_HUB,
  'Κηφισιά': NORTHERN_HUB,
  'Μαρούσι': NORTHERN_HUB,
  'Αγία Παρασκευή': NORTHERN_HUB,
  'Χολαργός': NORTHERN_HUB,
  'Βρίλήσσια': NORTHERN_HUB,
  'Βριλήσσια': NORTHERN_HUB,
  'Παπάγου': NORTHERN_HUB,
  'Μελίσσια': NORTHERN_HUB,
  'Πεντέλη': NORTHERN_HUB,
  'Βόρεια Προάστια': NORTHERN_HUB,
  'Αθήνα': '/best-hair-salon-athens',
};

export const getAreaHref = (area) => AREA_LINKS[area] || null;

// Reverse lookup: area page slug → area name.
const SLUG_NAMES = {
  'kommotirio-chalandri': 'Χαλάνδρι',
  'kommotirio-voreia-proastia': 'Βόρεια Προάστια',
};

export const getAreaNameBySlug = (slug) => SLUG_NAMES[slug] || null;